// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3JcNI","content":"Consent_content__e2nUC","footer":"Consent_footer__2ylt9"};